<template>
  <div>
    <footer class="footer">
      <div class="footer-content">
        <div class="footer-section">
          <h3>Contacto</h3>
          <div class="contact-info">
            <a
              href="https://api.whatsapp.com/send/?phone=541135090004&text&type=phone_number&app_absent=0"
              target="_blank"
              class="contact-link"
            >
              📱 WhatsApp
            </a>
            <a href="tel:1135090004" class="contact-link"> 📞 1135090004 </a>
            <a href="mailto:grupomonjessrl@gmail.com" class="contact-link">
              ✉️ Email
            </a>
          </div>
        </div>

        <div class="footer-section">
          <h3>Redes Sociales</h3>
          <div class="contact-info">
            <a
              href="https://www.instagram.com/merheje.argentina"
              target="_blank"
              class="contact-link"
            >
              📷 Instagram
            </a>
            <a
              href="https://www.facebook.com/merheje.argentina"
              target="_blank"
              class="contact-link"
            >
              📘 Facebook
            </a>
            <a
              href="https://www.youtube.com/@merhejeargentina"
              target="_blank"
              class="contact-link"
            >
              📺 YouTube
            </a>
          </div>
        </div>

        <div class="footer-section">
          <h3></h3>
          <div class="contact-info">
            <a
              href="https://x.com/MerhejeA?s=09"
              target="_blank"
              class="contact-link"
            >
              🐦 Twitter/X
            </a>
            <a
              href="https://www.tiktok.com/@merhejeargentina?_t=8jgwhxhqzjx&_r=1&fbclid=pazxh0bgnhzw0cmteaaackqagmipoafvlqs8xx_z_cfy0lq85rudq4wvrcuywlvusu4p6bvnkrzrvu-a_aem_duulpubibllyn95s27cs-g"
              target="_blank"
              class="contact-link"
            >
              🎵 TikTok
            </a>
            <a
              href="https://www.linkedin.com/company/grupo-monjes-srl/"
              target="_blank"
              class="contact-link"
            >
              💼 LinkedIn
            </a>
          </div>
        </div>

        <div class="footer-section">
          <h3>Ubicación</h3>
          <p class="location">📍 Ciudad Autonoma de Buenos Aires ARGENTINA</p>
          <router-link
            to="/donde-encontrarnos"
            class="contact-link"
            style="margin-top: 1rem"
          >
            🗺️ Donde Encontrarnos
          </router-link>
        </div>

        <div class="footer-section">
          <h3>Información Fiscal</h3>
          <br />
          <a href="#" class="fiscal-link">
            <img
              src="/afip-qr.jpeg"
              alt="QR-AFIP"
              loading="lazy"
              decoding="async"
            />
          </a>
        </div>
      </div>

      <div class="footer-bottom">
        <p>© 2025 Merheje. Todos los derechos reservados.</p>
      </div>
    </footer>
  </div>
</template>
<script setup></script>
<style scoped>
.footer {
  width: 100%;
  background: linear-gradient(135deg, #111 0%, #2d2d2d 100%);
  color: #fff;
  padding: 3rem 2rem 1rem;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
}

.footer-section {
  text-align: left;
}

.footer-section h3 {
  color: #fff;
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 1rem;
  border-bottom: 2px solid #da1884;
  padding-bottom: 0.5rem;
  display: inline-block;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.contact-link {
  color: #e0e0e0;
  text-decoration: none;
  font-size: 1rem;
  transition: color 0.3s ease, transform 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.contact-link:hover {
  color: #da1884;
  transform: translateX(5px);
}

.location {
  color: #e0e0e0;
  font-size: 1rem;
  line-height: 1.6;
  margin: 0;
}

.fiscal-link {
  color: #e0e0e0;
  text-decoration: none;
  font-size: 1rem;
  transition: color 0.3s ease, transform 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.fiscal-link:hover {
  color: #da1884;
  transform: translateX(5px);
}

.footer-bottom {
  border-top: 1px solid #444;
  padding-top: 1rem;
  text-align: center;
  color: #999;
  font-size: 0.9rem;
}

.footer-bottom p {
  margin: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
  .footer {
    padding: 2rem 1rem 1rem;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    text-align: center;
  }

  .footer-section {
    text-align: center;
  }

  .footer-section h3 {
    font-size: 1.1rem;
  }

  .contact-info {
    align-items: center;
  }

  .contact-link,
  .fiscal-link {
    justify-content: center;
    font-size: 0.95rem;
  }

  .location {
    font-size: 0.95rem;
  }
}

@media (max-width: 480px) {
  .footer {
    padding: 1.5rem 0.5rem 1rem;
  }

  .footer-content {
    gap: 1rem;
  }

  .footer-section h3 {
    font-size: 1rem;
  }

  .contact-link,
  .fiscal-link,
  .location {
    font-size: 0.9rem;
  }
}
</style>
